var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_1376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 7.99795L16.0969 4.79999V26.9385C9.06887 23.9864 6.25781 18.3288 6.25781 15.1316V7.99795Z",
    fill: "#424246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9367 7.99795L16.0977 4.79999V26.9385C23.1257 23.9864 25.9367 18.3288 25.9367 15.1316V7.99795Z",
    fill: "url(#paint0_linear_1810_1376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9367 7.99795L16.0977 4.79999V26.9385C23.1257 23.9864 25.9367 18.3288 25.9367 15.1316V7.99795Z",
    fill: "url(#paint1_linear_1810_1376)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1810_1376",
    x1: 15.6822,
    y1: 29.721,
    x2: 23.736,
    y2: 0.591896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0500FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1810_1376",
    x1: 23.1395,
    y1: 3.52048,
    x2: 15.7075,
    y2: 26.9068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#424246"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_1376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.932,
    height: 22.4,
    fill: "white",
    transform: "translate(6.07422 4.79999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/TRUST.f59a2d4c33e2aa857bcd5014ae67f78f.svg";
export { ForwardRef as ReactComponent };